var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13208 14.1161H6.64151C6.64151 14.872 7.2483 15.4821 8 15.4821C8.7517 15.4821 9.35849 14.872 9.35849 14.1161H10.8679C10.8679 15.7098 9.58491 17 8 17C6.41509 17 5.13208 15.7098 5.13208 14.1161ZM16 11.9911V12.2946C16 13.0505 15.3902 13.6607 14.6415 13.6607H1.35849C0.606792 13.6607 0 13.0505 0 12.2946V11.9911C0 10.8891 0.778868 9.97232 1.81132 9.75982V6.22321C1.81132 2.78375 4.58264 0 8 0C11.4174 0 14.1887 2.78679 14.1887 6.22321V9.75982C15.2242 9.97232 16 10.8891 16 11.9911ZM14.4906 11.9911C14.4906 11.5721 14.1525 11.2321 13.7328 11.2321C13.1502 11.2321 12.6792 10.7555 12.6792 10.1727V6.22321C12.6792 3.62464 10.5842 1.51786 8 1.51786C5.41585 1.51786 3.32075 3.62464 3.32075 6.22321V10.1727C3.32075 10.7586 2.84679 11.2321 2.26717 11.2321C1.84755 11.2321 1.50943 11.5721 1.50943 11.9911V12.1429H14.4906V11.9911Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.0fcfac4109b240ef3fca452cf178c665.svg";
export { ForwardRef as ReactComponent };